import { formatCurrency, getCurrencyFormat, getCurrencySymbol } from './currency.js';
const parseAmount = (amount) => {
    if (typeof amount === 'number')
        return amount;
    if (typeof amount === 'string') {
        return parseFloat(amount.replace(/[,_]/gu, ''));
    }
    throw new Error('unexpected price type');
};
export const formatPrice = (price, { useGrouping = true, currency = 'USD', format, minimumFractionDigits, maxFraction = 2, formatZeroWithoutDecimals = true, } = {}) => {
    const priceNumber = parseAmount(price);
    const currencySymbol = getCurrencySymbol(currency);
    const currencyFormat = format || getCurrencyFormat(currency);
    if (minimumFractionDigits && minimumFractionDigits > maxFraction) {
        throw new Error('minimumFractionDigits cannot be greater than maxFraction');
    }
    const result = formatCurrency(priceNumber, {
        minimumFractionDigits: priceNumber === 0
            ? 0
            : minimumFractionDigits === undefined
                ? Math.min(maxFraction, 2)
                : minimumFractionDigits,
        maximumFractionDigits: priceNumber === 0 ? 0 : maxFraction,
        format: currencyFormat,
        symbol: currencySymbol,
        useGrouping,
    });
    if (formatZeroWithoutDecimals && parseFloat(result.replace(currencySymbol || '', '')) === 0) {
        return formatCurrency(0, {
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
            format: currencyFormat,
            symbol: currencySymbol,
            useGrouping,
        });
    }
    return result;
};
export function formatPriceUSD(price) {
    return formatPrice(price);
}
export function formatAssetPrice({ price, currency, decimals: decimalsFromProps, formatZeroWithoutDecimals = true, }) {
    const maxFraction = decimalsFromProps || getFiatAdaptiveFraction(price);
    return formatPrice(price.toString(), {
        currency,
        maxFraction,
        useGrouping: true,
        formatZeroWithoutDecimals,
    });
}
export const getFiatAdaptiveFraction = (price) => {
    price = Number(price);
    return price === 0 ? 2 : price >= 1 ? 2 : price >= 0.0001 ? 4 : 6;
};
export const formatAmount = (amount, { minimumFractionDigits = 0, ...rest } = {}) => {
    return formatPrice(amount, { minimumFractionDigits, ...rest });
};
